import { useDataProvider } from "@exonn/base";
import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { useResourceQueries } from "@exonn/base";
import { useContentLocale } from "src/auth/hooks/useContentLocale.tsx";

export const useCreateForm = <FormData = any,>(props: {
  resource: string;
  locale?: string;
  requestParams?: Record<string, any>;
  pretend?: boolean;
  meta?: any;
  queryOptions?: Omit<
    UseQueryOptions<FormData, any, FormData>,
    "queryFn" | "queryKey"
  >;
}) => {
  const {
    resource,
    locale: localeProp,
    meta: metaProp,
    pretend,
    queryOptions,
    requestParams,
  } = props;
  const dataProvider = useDataProvider();
  const queries = useResourceQueries();
  const defaultLang = useContentLocale();
  const locale = localeProp || defaultLang;

  const meta = {
    ...metaProp,
    pretend,
    requestParams,
    locale: locale,
  };

  const queryParams = {
    resource,
    meta,
  };
  return useQuery({
    queryKey: queries.createFormData(queryParams),
    queryFn: ({ signal }) => {
      return dataProvider.getCreateFormData({
        signal,
        ...queryParams,
      });
    },
    ...queryOptions,
  });
};
